import React, { FC } from 'react';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { RocheUITag } from '@repo/roche-ui';
import { useTranslation } from '../../hooks/use-translation';
import { StringService } from '../../services/string';
import { handleTagClick } from '../../helpers/roche-tag-tracking';
import { getTagPageUrl } from '../../services/dom/util';
import { LanguageService } from '../../services/language';

type RocheTagProps = BlokToComponentProps<{
  tag: string;
}>;

export const RocheTag: FC<RocheTagProps> = ({ blok: { tag } }) => {
  const translatedTag = useTranslation(tag);
  const openLinkTranslation = useTranslation('view all topics tagged with');

  const currentLanguage = LanguageService.getActiveLanguage();
  const baseTagPageUrl = getTagPageUrl();
  const tagPageUrl = LanguageService.getLocaleAwareLink(baseTagPageUrl, currentLanguage);
  const tagUrlfied = StringService.urlify(translatedTag);
  const tagUrl = tagPageUrl && tagUrlfied ? `${tagPageUrl}/${tagUrlfied}` : '';

  const handleClick = () => {
    handleTagClick(tag, translatedTag, tagUrl);
  };

  return (
    <RocheUITag tag={tag} href={tagUrl} onClick={handleClick} ariaLabel={`${openLinkTranslation} ${translatedTag}`} />
  );
};
